import { render } from "./OptionsRelations.vue?vue&type=template&id=b43dec86"
import script from "./OptionsRelations.vue?vue&type=script&lang=js"
export * from "./OptionsRelations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__